import { Button, useMediaQuery, useTheme } from '@mui/material';

interface IProps {
  onClick: () => void;
}

export const ClaimAccountButton = ({ onClick }: IProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Button id="claim-account-button__components-claim-account__button__l12"
    variant="contained"
    size={isMobile ? 'small' : 'medium'}
    sx={{ color: theme.palette.common.white, textTransform: 'uppercase', borderRadius: '10px' }}
    onClick={onClick}>
      
      Claim Account
    </Button>);

};